// Is this component still being used??
import React, { Component } from 'react';
import { NavLink, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Carousel } from 'react-responsive-carousel';
import { fetchProduct } from 'Actions';
import { EditCircle, Items } from 'Utils/SvgIcons';
import CurrencyLabel from 'Utils/CurrencyLabel';
import { selectCheckPermission } from 'HelperFunctions/locations';
import ShareItemContainer from './multilocation/ShareItemContainer';
import MoveInventoryContainer from './multilocation/MoveInventoryContainer';
import ItemCalendarContainer from '../calendars/ItemCalendarContainer';
import NewMaintenancePop from './NewMaintenancePop';
import DeleteProduct from './DeleteProduct';
import DeleteMultilocationProduct from './DeleteMultilocationProduct';
import { history } from 'Components/utils/router/history';
import MultilocationSummary from './multilocation/MultilocationSummary';
import Imgix from 'react-imgix';
import InventoryNavLinks from 'Utils/InventoryNavLinks';

class ProductMultilocation extends Component {
  componentDidMount() {
    this.props.fetchProduct('product', this.props.match.params.id);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { product } = nextProps;
    if (product.id) {
      if (!product.businessInfo.multilocationEnabled) {
        history.push('/inventory/items/' + product.token);
      }
    }
  }

  render() {
    const {
      match: { params },
      product,
      checkPermission,
    } = this.props;

    const usageUnitsAvailable =
      product.usageUnits && product.usageUnits.length > 0;

    return (
      <div className='contentWrapper'>
        <div className='content product'>
          {checkPermission('edit_add_inventory') && (
            <Link
              to={'/inventory/items/' + params.id + '/edit'}
              className='btnLink'
            >
              Edit
              <EditCircle />
            </Link>
          )}
          <InventoryNavLinks params={params} product={product} />
          <div className='image'>
            {product.pictures !== undefined && product.pictures.length > 0 ? (
              product.pictures.length > 1 ? (
                <Carousel
                  showArrows={false}
                  showThumbs={false}
                  showStatus={false}
                  infiniteLoop={true}
                  autoPlay={true}
                  interval={8000}
                >
                  {product.pictures.map((picture) => {
                    return (
                      <figure>
                        <Imgix
                          key={picture.id}
                          src={picture.imgixUrl}
                          alt={picture.imgixUrl}
                          width={510}
                          height={288}
                        />
                      </figure>
                    );
                  })}
                </Carousel>
              ) : (
                <ul className='carousel'>
                  <li key={product.pictures[0].id}>
                    <figure>
                      <Imgix
                        src={product.pictures[0].imgixUrl}
                        alt={product.pictures[0].imgixUrl}
                        width={510}
                        height={288}
                      />
                    </figure>
                  </li>
                </ul>
              )
            ) : (
              <figure>
                <Items />
              </figure>
            )}
          </div>

          <div className='summary'>
            <div className='token'>#{product.token}</div>
            <MultilocationSummary product={product} />
            {(product.hourlyPrice ||
              product.halfDayPrice ||
              product.dailyPrice ||
              product.weeklyPrice ||
              product.monthlyPrice) && (
              <div className='summaryPricing'>
                <h6>Pricing</h6>
                {product.hourlyPrice && (
                  <div>
                    <CurrencyLabel value={product.hourlyPrice} />
                    <label>/Hour</label>
                  </div>
                )}
                {product.halfDayPrice && (
                  <div>
                    <CurrencyLabel value={product.halfDayPrice} />
                    <label>/Half-Day</label>
                  </div>
                )}
                {product.dailyPrice && (
                  <div>
                    <CurrencyLabel value={product.dailyPrice} />
                    <label>/Day</label>
                  </div>
                )}
                {product.weeklyPrice && (
                  <div>
                    <CurrencyLabel value={product.weeklyPrice} />
                    <label>/Week</label>
                  </div>
                )}
                {product.monthlyPrice && (
                  <div>
                    <CurrencyLabel value={product.monthlyPrice} />
                    <label>/Month</label>
                  </div>
                )}
                {product.flatPrice && (
                  <div>
                    <CurrencyLabel value={product.flatPrice} />
                    <label>/Each</label>
                  </div>
                )}
              </div>
            )}
            <NewMaintenancePop
              productType='product'
              inventoryProduct={product}
            />
          </div>

          <ShareItemContainer product={product} productType='items' />
          {product.multilocationShared && product.groupInfo && (
            <MoveInventoryContainer product={product} productType='items' />
          )}
          {product.id !== '' && (
            <ItemCalendarContainer product={product} productType='items' />
          )}

          {product.multilocationShared ? (
            <DeleteMultilocationProduct
              id={params.id}
              name={product.name}
              type='item'
            />
          ) : (
            <DeleteProduct id={params.id} name={product.name} type='item' />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  product: state.products.product,
  location: state.location.location,
  user: state.user.user,
  loading: state.products.loading,
  checkPermission: selectCheckPermission(state),
});

export default connect(mapStateToProps, { fetchProduct })(ProductMultilocation);
